export default function NavButtonDownload() {
  return {
    scope: {
      active: '=',
      disabled: '=',
      click: '&'
    },
    restrict: 'E',
    transclude: true,
    constructor: ($scope, $element) => {
      'ngInject';

      if ($scope.active) {
        $element.addClass('active');
      }
    },
    template: `<button type="button" class="btn btn-primary btn-sm" ng-disabled="disabled" ng-click="click()" ng-transclude></button>`
  };
}
